import type { ElementType } from 'react';
import DOMPurify from 'dompurify';

/**
 * Sanitizes an HTML string using DOMPurify, then renders it via
 * `dangerouslySetInnerHTML`.  This is the React replacement for Angular's
 * `safeHtml` pipe.
 *
 * Only call this for HTML that originates from a trusted back-end API; never
 * pass user-supplied raw HTML here without additional review.
 */
interface SafeHtmlProps {
  html: string;
  className?: string;
  /** Override the container tag. Defaults to "div". */
  as?: keyof React.JSX.IntrinsicElements;
}

export function SafeHtml({ html, className, as = 'div' }: SafeHtmlProps) {
  const Tag = as as ElementType;
  const clean = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel'],
  });

  return (
    // eslint-disable-next-line react/no-danger
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
